import { CalendarIcon } from "@heroicons/react/20/solid";
import { SeasonEvent } from "../../models/leagueInterfaces";
import { formatDate } from "../../utils/dateUtils";

interface SeasonEventsProps {
  events: SeasonEvent[] | undefined;
}
export const SeasonEvents: React.FC<SeasonEventsProps> = ({ events }) => {
  if (!events) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-gray-500">There are no events</p>
      </div>
    );
  }
  return (
    <div className="p-8 ">
      <ul role="list" className="-mb-8">
        {events.map((event, eventIdx) => (
          <li key={event.id}>
            <div className="relative pb-8">
              {eventIdx !== events.length - 1 ? (
                <span
                  aria-hidden="true"
                  className="absolute left-[13px] top-4 -ml-px h-full w-2 bg-gray-400"
                />
              ) : null}
              <div className="relative flex">
                <span className="flex h-8 w-8 items-center justify-center rounded-full ring-8 ring-white bg-green-500">
                  <CalendarIcon
                    aria-hidden="true"
                    className="h-5 w-5 text-white "
                  />
                </span>
                <div className="flex flex-wrap min-w-0 flex-1 justify-between space-x-4 pt-1 pl-5">
                  <p className="text-lg text-gray-500">{event.eventName} </p>
                  <div className="whitespace-nowrap text-right text-sm text-gray-500">
                    {formatDate(event.date)}
                  </div>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
